
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacHeader extends Vue {
    @Prop({ default: '/' }) public link!: string;
}
